<template>
  <v-container grid-list-md text-xs-center class="pa-0" >
        <v-card class="card-r no-shadow grey lighten-4 scroll-y" style="height:50vh;">
            <v-layout row wrap>
            <v-flex class="hide-pro" xs12 lg3>
              <v-select solo
                v-model="classType"
                :items="types"
                class="input-group--focused"
                label="Class Type"
                type="text"
              ></v-select>
            </v-flex>
            <v-flex class="hide-pro" xs12 lg3 v-if="classType=='other'">
                <v-text-field solo v-model="otherType" :rules="requiredRule" label="Type Class type"></v-text-field>
            </v-flex>
            <v-flex class="hide-pro" lg3 xs12>
              <v-text-field solo :rules="requiredRule" v-model="classTitle" label="Class Title"></v-text-field>
            </v-flex>
            <v-flex class="hide-pro" xs12 lg3>
              <v-text-field
                solo v-model="classLocation" label="Class Location"></v-text-field>
            </v-flex>
            <v-flex class="hide-pro" xs12 lg3>
                <v-select solo
                          v-model="classHours"
                          :items="workMin"
                          class="input-group--focused"
                          label="Minutes (Class Minutes can add here)"
                          type="number"
                ></v-select>
              </v-flex>
            <v-flex xs12 lg12 class="text-xs-left mb-3">
              <v-flex class="white shadow-1 pt-2">
                <div class="text-xs-left text-primary ml-2 f-9">Description Tags</div>
                <treeselect outline class="" placeholder="Description" v-model="value" search-nested :always-open="false" :append-to-body="true" :multiple="true" :options="options" />
             </v-flex>
           </v-flex>
            <v-flex xs12 lg12 class="pt-0 pb-0 hide-pro">
            <v-textarea solo class="redius-5" name="input-7-1" v-model="sms_content" label="Sms" ></v-textarea>
          </v-flex>
            <v-flex xs12 lg12 class="pt-0 pb-0 hide-pro">
            <v-textarea solo class="redius-5" name="input-7-1" v-model="email_content" label="Email" ></v-textarea>
          </v-flex>
            <!-- <v-flex lg12 sm12 xs12 class="pt-0 pb-0" >
              <v-menu
                ref="dialog1"
                :close-on-content-click="false"
                v-model="datePickMenu"
                :return-value.sync="classDate"
                lazy
                persistent
                full-width
                min-width="290px"
              >
                <v-text-field
                  solo
                  slot="activator"
                  v-model="classDate"
                  label="Date"
                  placeholder="dd/mm/yyyy"
                  solo
                  readonly
                  required
                ></v-text-field>
                <v-date-picker v-model="classDate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="datePickMenu = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialog1.save(classDate)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 lg2>
                <v-autocomplete
                  solo
                  v-model="classTime"
                  item-value="value"
                  item-text="text"
                  :items="timeslot"
                  label="Time"
                  placeholder="start time">
                </v-autocomplete>
            </v-flex> -->
            <!-- <v-flex>
              <v-text-field v-model="classPrice" type="number" label="Class Price"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field v-model="internalPrice" type="number" label="Internal Price"></v-text-field>
            </v-flex> -->
            <v-flex xs12 lg12>
              <v-textarea solo name="input-7-1" v-model="description" label="Description" ></v-textarea>
            </v-flex>
            <v-flex xs12 lg12>
               <v-checkbox class="ma-0 pa-0"
                  v-model="unlimitedTick"
                  label="Tick if you need unlimited number of bookings"
                ></v-checkbox>
            </v-flex>
            <!--<v-flex xs12 lg12 class="pt-0 pb-0 hide-pro">-->
              <!--<v-textarea solo class="redius-5" name="input-7-1" v-model="sms_content" label="Sms" ></v-textarea>-->
            <!--</v-flex>-->
              <!--<v-flex xs12 lg12 class="pt-0 pb-0 hide-pro">-->
              <!--<v-textarea solo class="redius-5" name="input-7-1" v-model="email_content" label="Email" ></v-textarea>-->
            <!--</v-flex>-->
            <!-- <v-flex>
              <v-textarea name="input-7-1" v-model="description" label="Descriddption" ></v-textarea>
            </v-flex> -->
            <!-- <v-flex>
              <v-combobox
                v-model="value"
                :items="options"
                :search-input.sync="search"
                hide-selected
                hint="Maximum of 5 tags"
                label="Add some tags"
                multiple
                persistent-hint
                small-chips
              >
                <template v-slot:no-data>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        No results matching "<strong>{{ search }}</strong>". Press <kbd>enter</kbd> to create a new one
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-combobox>
            </v-flex> -->

            </v-layout>
        </v-card>
          <!-- <v-flex xs12 md-6 class>
            <input
              solo
              multiple
              type="file"
              ref="ImgInput"
              style="display: none"
              accept="image/*"
              @change="onImgPicked"
            >
            <v-btn small class="card-r" solo @click="onPickImg">Upload Gallery</v-btn>
          </v-flex> -->
          <!-- <v-flex xs12 style="display:flex; overflow-x: scroll;">
            <v-flex class="ma-2" v-for="url in attachment.galleryURL" :key="url" xs12>
              <v-card flat tile flex>
               <div class="w-100 text-xs-right">
                 <v-btn icon color="grey lighten-2"><v-icon>close</v-icon></v-btn>
               </div>
                <v-img
                  :src="url"
                  style="height: 100px; width: 100px !important;"
                  :lazy-src="url"
                  aspect-ratio="1"
                  class="grey lighten-2"
                >
                  <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-layout>
                </v-img>
              </v-card>
            </v-flex>
          </v-flex> -->
          <v-flex xs12 class="text-xs-center">
              <v-progress-circular
                  indeterminate
                  v-if=loading
                  color="primary"
              ></v-progress-circular>
              <v-alert
                :value="true"
                color="success"
                icon="check_circle"
                v-if="alert.type=='success'"
                outline
              >
                {{alert.msg}}
              </v-alert>
              <v-alert
                :value="true"
                color="error"
                icon="warning"
                v-if="alert.type=='warning'"
                outline
              >
                {{alert.msg}}
              </v-alert>
          </v-flex>
            <v-btn @click="AddModule" color="primary darken-2 no-shadow card-r right" slot="activator" dark>Finish</v-btn>
  </v-container>
</template>
<script>
  /* eslint-disable */

  import ConfirmSignup from "@/components/pages/WidgetComponents/ConfirmPopup";
import FormData from "form-data";
import api from '@/utils/backend-api.js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {

  data: () => ({
    classTitle: "",
    classLocation: "",
    classHours: "",
    classType:"",
    classPrice: "",
    internalPrice: "",
    classDescription:"",
    description: "",
    attachment: {
      galleries: [],
      galleryURL: [],
      photosURL: [],
      videos: [],
      videosURL: [],
      e7: [],

    },
    requiredRule: [v => !!v || "This field is required"],
    workMin: ["45", "90", "135", "180"],
    types:[
        {text:'Teori',value:'teori'},
        {text:'Kørsel',value:'kørsel'},
        {text:'Manøvre',value:'manøvre'},
        {text:'Glatbane',value:'glatbane'},
        {text:'Other',value:'other'}
    ],
    otherType:'',
    states: [
          'Alabama', 'Alaska', 'American Samoa', 'Arizona'
    ],
    options: [],
    tagId:{
      parent:[],
      child:[],
      childOfChild:[]
    },
    loading:false,
    alert:{
      type:'',
      msg:''
    },
    value:[],
    unlimitedTick:false,
    datePickMenu:false,
    timePickMenu:false,
    classDate:'',
    classTime:'',
    timeslot: [
      {text:'07:00 am',value:'07:00'},
      {text:'07:30 am',value:'07:30'},
      {text:'08:00 am',value:'08:00'},
      {text:'08:30 am',value:'08:30'},
      {text:'09:00 am',value:'09:00'},
      {text:'09:30 am',value:'09:30'},
      {text:'10:00 am',value:'10:00'},
      {text:'10:30 am',value:'10:30'},
      {text:'11:00 am',value:'11:00'},
      {text:'11:30 am',value:'11:30'},
      {text:'12:00 pm',value:'12:00'},
      {text:'12:30 pm',value:'12:30'},
      {text:'01:00 pm',value:'13:00'},
      {text:'01:30 pm',value:'13:30'},
      {text:'02:00 pm',value:'14:00'},
      {text:'02:30 pm',value:'14:30'},
      {text:'03:00 pm',value:'15:00'},
      {text:'03:30 pm',value:'15:30'},
      {text:'04:00 pm',value:'16:00'},
      {text:'04:30 pm',value:'16:30'},
      {text:'05:00 pm',value:'17:00'},
      {text:'05:30 pm',value:'17:30'},
      {text:'06:00 pm',value:'18:00'},
      {text:'06:30 pm',value:'18:30'},
    ],
    sms_content:'',
    email_content:''

  }),
  watch: {},
  created() {
        api.postData('tag/viewTag')
        .then(res=>{
          this.options=res.data
          this.storeTagId(res.data)
        }).catch(err=>{

        })
        Store.dispatch('Modules/getAllClasses')
  },


  methods: {
    storeTagId(Tags){
        let parent=[]
        let child=[]
        let childOfChild=[]
        Tags.forEach(function(element,index){
          parent.push(element.id)
          if(Tags[index].children){
            let children=Tags[index].children
            children.forEach(function(elementC,indexC){
              child.push(children[indexC].id)

              if(Tags[index].children[indexC].children){
                // console.log(Tags[index].children[indexC].children)
                let childrenOfChild=Tags[index].children[indexC].children
                childrenOfChild.forEach(function(elementCC,indexCC){
                  childOfChild.push(childrenOfChild[indexCC].id)
                })
              }
            })
          }
        })
        this.tagId.parent=parent
        this.tagId.child=child
        this.tagId.childOfChild=childOfChild
    },
    print(){
        console.log(this.value)
    },
    TagIdAnalyze(tagIdList){
      let oldParent=this.tagId.parent
      let oldChild=this.tagId.child
      let oldchildOfChild=this.tagId.childOfChild
      let finalParent=[]
      let finalChild=[]
      let finalChildOfChild=[]
      if(tagIdList){
          console.log("tagIdList")
          console.log(tagIdList)
          tagIdList.forEach(function(element,index){
            console.log(element)
            oldParent.forEach(function(elementP,indexP){
              // console.log(elementP)
                if(elementP==element){
                  finalParent.push(elementP)
                }
            })
            oldChild.forEach(function(elementC,indexC){
                if(elementC==element){
                  finalChild.push(elementC)
                }
            })
            oldchildOfChild.forEach(function(elementCC,indexCC){
                if(elementCC==element){
                  finalChildOfChild.push(elementCC)
                }
            })
          })
      }
      return {finalParent,finalChild,finalChildOfChild};
    },
    AddModule() {
      // console.log(this.attachment);
      // console.log(this.value)
      this.loading=true
      this.alert.type=""
      var FinalTagIdList={}
      var {finalParent,finalChild,finalChildOfChild}=this.TagIdAnalyze(this.value)
      var moduleDetails = {
        name: this.classTitle,
        location: this.classLocation,
        hours: this.classHours,
        type:this.classType,
        price: this.classPrice,
        internal_price: this.internalPrice,
        description:this.classDescription,
        // image: this.attachment.galleries,
        parent:finalParent,
        child:finalChild,
        sub_child:finalChildOfChild,
        image_count:this.attachment.galleries.length
      };

      let classType
      if(this.unlimitedTick==true){
          classType="unlimited"
      }else{
          classType="limited"
      }


      for(var x=0;x<this.attachment.galleries.length;x++){
        moduleDetails['image'+x]=this.attachment.galleries[x]
      }


      var formData = new FormData();
      formData.append("name", this.classTitle);
      formData.append("location", this.classLocation);
      formData.append("hours", this.classHours);
      formData.append("type", this.classType);
      formData.append("description", this.classDescription);
      formData.append("sms_content", this.sms_content);
      formData.append("email_content", this.email_content);
      if(this.classType=='other'){
        formData.append("other_type", this.otherType);
      }

      formData.append("booking_status", classType);

      // formData.append("parent[]", JSON.stringify(finalParent));
      if(finalParent && finalChild && finalChildOfChild){
          for (var x = 0; x < finalParent.length; x++) {
            formData.append("parent[]", finalParent[x]);
          }
          // formData.append("child", JSON.stringify(finalChild));
          for (var x = 0; x < finalChild.length; x++) {
            formData.append("child[]", finalChild[x]);
          }
          // formData.append("sub_child", JSON.stringify(finalChildOfChild));
          for (var x = 0; x < finalChildOfChild.length; x++) {
            formData.append("sub_child[]", finalChildOfChild[x]);
          }
          // for (var x = 0; x < this.attachment.galleries.length; x++) {
          //   formData.append("image" + x, this.attachment.galleries[x]);
          // }
      }
      // var count = this.attachment.galleries.length;
      // formData.append("image_count", count);

      // formData.append('image', ImageArray)
      // var files=this.attachment.galleries
      // var myArray=[]
      // for(var i = 0; i < files.length; i++){
      //   var file = {
      //     'lastMod'    : files[i].lastModified,
      //       'lastModDate': files[i].lastModifiedDate,
      //       'name'       : files[i].name,
      //       'size'       : files[i].size,
      //       'type'       : files[i].type,
      //   }
      //   myArray.push(file)
      // }
      // console.log(myArray);

      // formData.append('image', myArray)

      // Object.keys(moduleDetails).forEach(key => formData.append(key, moduleDetails[key]));
      console.log(formData);
        const config = {
          headers: {
              'content-type': 'multipart/form-data'
          }
        }
        api.postData('admin/module/create', formData,config).then(res => {
          console.log(res)
              if(res.status==201){
                  this.loading=false
                  this.alert.type="success"
                  this.alert.msg="Class Created Successfully"
                  Store.dispatch('Modules/getAllClasses')
                  setTimeout(() => {
                    this.$router.push("/classes");
                  }, 2500);
              }
        }).catch((error) => {
            console.log(error)
            this.loading=false
            this.alert.type="warning"
            this.alert.msg="Class not created"
        })
      // this.$store.dispatch("Modules/AddModule", formData).then(res => {
      //   console.log(res);
      //   this.loading=false
      //   this.alert.type="success"
      //   this.alert.msg="Class Created Successfully"
      //   setTimeout(() => {
      //     this.$router.push("/classes");
      //   }, 1000);
      // }).catch(error=>{
      //   console.log(error)
      //   this.loading=false
      //   this.alert.type="warning"
      //   this.alert.msg="Class not created"
      // });
    },
    // onPickImg() {
    //   this.$refs.ImgInput.click();
    // },
    // onImgPicked() {
    //   const files = event.target.files;
    //   console.log(files);
    //   if (files.length == 1) {
    //     console.log(files[0]);
    //     this.attachment.galleries.push(files[0]);
    //   } else {
    //     for (var i = 0; i < files.length; i++) {
    //       this.attachment.galleries.push(files[i]);
    //     }
    //   }
    //   for (var i = 0; i < files.length; i++) {
    //     let fileName = files[i].name;
    //     if (fileName.lastIndexOf(".") <= 0) {
    //       return alert("Please add a valid file! ");
    //     }
    //     console.log(fileName);
    //   }
    //   for (var i = 0; i < files.length; i++) {
    //     const fileReader = new FileReader();
    //     fileReader.readAsDataURL(files[i]);
    //     // console.log(fileName)
    //     // var fileName
    //     fileReader.addEventListener("load", () => {
    //       this.attachment.galleryURL.push(fileReader.result);
    //       // console.log( this.attachment.galleryURL);
    //     });
    //   }

    //   console.log(this.attachment);
    // }
  },
  components: {
    ConfirmSignup,
    Treeselect
  }
};
</script>
<style>
.v-dialog {
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/WidgetComponents/CreateClass.vue